import { Color } from './color';
/**
 * ▼
 */
export const TriangleDown = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'fill', symbol: 'triangle-down' }, options), context);
};
TriangleDown.props = Object.assign({ defaultMarker: 'triangleDown' }, Color.props);
//# sourceMappingURL=triangleDown.js.map